import moment from 'moment';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import * as debtRegister from '@debbie/common/dist/debt-register/index.js';
import { documentsWhichIsFoundations, DocumentTypes, RefIdTypes, } from '@debbie/common/dist/documents/index.js';
import { getCurrentPaymentPlan, PaymentPlanStatus, } from '@debbie/common/dist/economy/payment-plans/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import * as documentsAPI from '@debbie/cortex/dist/api/documents.js';
import { documentsEntity } from '@debbie/cortex/dist/documents/index.js';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { Button, DateInput, Select, File, FileDropzone, Checkbox, MoneyInput, } from '../index.js';
import { usePaymentPlansByCaseId } from '@debbie/cortex/dist/paymentPlans/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
const TribunalDocument = (props) => {
    const [submitting, setSubmitting] = useState(false);
    const [type, setType] = useState(null);
    const [date, setDate] = useState(new Date());
    const [amount, setAmount] = useState(null);
    const [signedDate, setSignedDate] = useState(new Date());
    const [signed, setSigned] = useState(false);
    const [document, setDocument] = useState(null);
    const dropzoneRef = useRef(null);
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const creditorLoadable = useCreditor(props.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const paymentPlansLoadable = usePaymentPlansByCaseId(props.kase.caseId);
    const paymentPlans = h.hasData(paymentPlansLoadable)
        ? paymentPlansLoadable.data
        : null;
    const customer = useSelector((s) => props.kase && selectCustomerById(s, props.kase.customerId));
    const paymentPlan = getCurrentPaymentPlan(paymentPlans);
    const canSave = type != null;
    const canBeSigned = type && documentsWhichIsFoundations.signingRequired.includes(type);
    return (React.createElement(FileDropzone, { dropzoneRef: dropzoneRef, onChange: setDocument },
        React.createElement(Wrapper, null,
            React.createElement(Select, { onChange: (e) => {
                    setType(e.target.value === '' ? null : e.target.value);
                }, value: type },
                React.createElement("option", { value: "" }, lang.documents.selectType),
                Object.values(DocumentTypes)
                    .filter((type) => ![
                    DocumentTypes.OTHER,
                    DocumentTypes.COURT,
                    DocumentTypes.FOUNDATION,
                ].includes(type))
                    .map((type) => (React.createElement("option", { key: type, value: type }, lang.documentTypes[type] || type)))),
            React.createElement(DateWrapper, null,
                React.createElement(DateInput, { placeholder: lang.documents.createdAt, value: moment(date), allowNull: false, onChange: (d) => {
                        setDate(d.toDate());
                    } })),
            React.createElement(MoneyInput, { value: amount || null, allowNull: true, placeholder: lang.documents.amount, onChange: (c) => setAmount(c === null ? c : Math.abs(c)) }),
            canBeSigned && (React.createElement(React.Fragment, null,
                React.createElement(Checkbox, { placeholder: lang.documents.documentSignedCheckbox, checked: signed, onChange: (e) => {
                        setSigned(e.target.checked);
                    } }),
                signed && (React.createElement(DateWrapper, null,
                    React.createElement(DateInput, { placeholder: lang.documents.signedAt, value: moment(signedDate), allowNull: false, onChange: (d) => {
                            setSignedDate(d.toDate());
                        } }))))),
            React.createElement(Button, { size: "small", theme: "secondary", style: { display: 'block', marginBottom: '20px' }, onClick: () => {
                    // @ts-ignore
                    dropzoneRef.current?.open();
                } }, lang.misc.chooseFile),
            document && (React.createElement(File, { file: document })),
            React.createElement(Button, { loading: submitting, disabled: !canSave, onClick: async () => {
                    if (type != null) {
                        const hasCreatedOrActivePaymentPlan = paymentPlan
                            ? [
                                PaymentPlanStatus.CREATED,
                                PaymentPlanStatus.ACTIVE,
                            ].includes(paymentPlan.status)
                            : false;
                        const autoRKIEnabled = debtRegister.isAutoRKIEnabled(tenant, creditor);
                        const autoRKIOpenEnabled = debtRegister.isAutoRKIOpenEnabled(tenant, creditor);
                        const autoMoveToOpenRKI = customer &&
                            debtRegister.canMoveToOpen(customer.users, {
                                signedAt: canBeSigned && signed
                                    ? signedDate.toISOString()
                                    : undefined,
                                date: date.toISOString(),
                                type: type,
                                meta: { amount },
                                refIdType: RefIdTypes.CASE,
                            });
                        if (autoRKIEnabled &&
                            autoRKIOpenEnabled &&
                            autoMoveToOpenRKI &&
                            !hasCreatedOrActivePaymentPlan) {
                            if (confirm(lang.documents.autoRKIAddFoundation)) {
                                setSubmitting(true);
                                await documentsAPI.add(props.kase.caseId, type, RefIdTypes.CASE, document?.fileId, signed, canBeSigned && signed ? signedDate : undefined, date, undefined, { amount });
                                q.invalidate(keys.write.create(documentsEntity));
                                props.onSubmit();
                                setSubmitting(false);
                            }
                        }
                        else {
                            setSubmitting(true);
                            await documentsAPI.add(props.kase.caseId, type, RefIdTypes.CASE, document?.fileId, signed, canBeSigned && signed ? signedDate : undefined, date, undefined, { amount });
                            q.invalidate(keys.write.create(documentsEntity));
                            props.onSubmit();
                            setSubmitting(false);
                        }
                    }
                } }, lang.misc.save))));
};
export default TribunalDocument;
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
const DateWrapper = styled.div `
  width: 100%;
  display: flex;
`;
//# sourceMappingURL=TribunalDocument.js.map